export const LANGUAGES = [
  {
    key: "uz",
    name: "O'zbek",
  },
  {
    key: "ru",
    name: "Ruscha",
  },
  {
    key: "en",
    name: "Inglizcha",
  }
]